import React, { useState } from 'react';

export default function SectionList({
  title,
  data,
  selectedId,
  onSelect,
  onDelete,
  onAdd,
  addPlaceholder,
  addValue,
  setAddValue,
  renderItem,
  onRightClick,
  extraInput,
  titleExtra, // Nouveau prop pour ajouter du contenu à côté du titre
}) {
  const [hoverDelete, setHoverDelete] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const sharedButtonStyle = {
    width: '100%',
    textAlign: 'left',
    padding: '16px 8px', // Hauteur réduite
    marginBottom: '6px',
    height: '30px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  return (
    <div style={{ marginBottom: '1.3rem' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          marginBottom: '0.5rem',
        }}
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <h2
          style={{
            margin: 0,
            fontSize: '1.2rem',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <span
            style={{
              fontSize: '0.8rem',
              transition: 'transform 0.2s',
              transform: isCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)',
              display: 'inline-block',
            }}
          >
            ▼
          </span>
          {title}
          {titleExtra && (
            <span onClick={(e) => e.stopPropagation()}>
              {titleExtra}
            </span>
          )}
        </h2>
        <span
          style={{
            fontSize: '0.9rem',
            color: '#666',
            backgroundColor: '#f0f0f0',
            padding: '2px 8px',
            borderRadius: '12px',
            fontWeight: '500',
          }}
        >
          {data.length}
        </span>
      </div>
      
      {!isCollapsed && (
        <>
          <div>
        {data.map((item) => (
          <button
            key={item.id}
            style={{
              ...sharedButtonStyle,
              backgroundColor: item.id === selectedId ? '#ccc' : '#fff',
            }}
            onClick={() => onSelect(item.id)}
            onContextMenu={(e) => {
              e.preventDefault();
              if (onRightClick) {
                onRightClick(item, e);
              }
            }}
          >
            {renderItem ? (
              renderItem(item)
            ) : (
              <span
                title={item.name}
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '70%',
                  display: 'inline-block',
                }}
              >
                {item.name}
              </span>
            )}
            <span
              onClick={(e) => {
                e.stopPropagation();
                onDelete(item.id);
              }}
              onMouseEnter={() => setHoverDelete(item.id)}
              onMouseLeave={() => setHoverDelete(null)}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '1.2rem',
                cursor: 'pointer',
                color: '#d2042d',
                marginLeft: '6px',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0',            // Assure qu'il n'y ait pas de padding perturbateur
                lineHeight: '20px',       // Pour un centrage vertical optimal
                borderRadius: '50%',      // Pour un rendu circulaire
                transition: 'background-color 0.3s ease',
                zIndex: 2,
                backgroundColor: hoverDelete === item.id ? '#e5e5e5' : 'transparent',
              }}
            >
              ×
            </span>

          </button>
        ))}
      </div>

      {/* Formulaire d'ajout */}
          <div
            style={{
              display: 'flex',
              gap: '4px',
              marginTop: '0.5rem',
            }}
          >
            <input
              type="text"
              placeholder={addPlaceholder}
              value={addValue}
              onChange={(e) => setAddValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onAdd();
                }
              }}
              autoComplete="one-time-code"
              autoCorrect="false"
              spellCheck="false"
              style={{
                flex: 1,
                padding: '6px',
                fontSize: '0.78rem',
                height: '16px',
                border: '1px solid #ddd',
                borderRadius: '8px',
              }}
            />
            {extraInput}
            <button
              onClick={onAdd}
              style={{
                backgroundColor: '#c7c7c7',
                textAlign: 'center',
                color: '#fff',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '1.8rem',
                height: '1.8rem',
                border: 'none',
                margin: '0px 0px',
                borderRadius: '7px',
                padding: '0px 0rem',
                cursor: 'pointer',
              }}
            >
              +
            </button>
          </div>
        </>
      )}
    </div>
  );
}
